import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Save, Loader2 } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const GatewaysTab = ({ headers }) => {
  const [gateways, setGateways] = useState([]);
  const [saving, setSaving] = useState(null);

  useEffect(() => { load(); }, []);

  const load = async () => {
    try {
      const res = await axios.get(`${API_URL}/api/gateways`);
      setGateways(res.data || []);
    } catch (e) {
      toast.error('Failed to load gateway pages');
    }
  };

  const setVideo = (slug, val) => {
    setGateways(gs => gs.map(g => g.slug === slug ? { ...g, video_url: val } : g));
  };

  const save = async (g) => {
    setSaving(g.slug);
    try {
      await axios.put(`${API_URL}/api/gateways/${g.slug}`, { video_url: g.video_url || '' }, { headers });
      toast.success(`${g.name} video saved`);
    } catch (e) {
      toast.error('Save failed');
    } finally {
      setSaving(null);
    }
  };

  return (
    <div data-testid="gateways-tab">
      <div className="mb-6">
        <h2 className="text-2xl font-bold text-[#0a0203]">Gateway Pages</h2>
        <p className="text-gray-500">Set the video shown on the Home Solutions and Repair off-site gateway pages. Paste an embed URL (YouTube/Vimeo). Leave blank to show a "video coming soon" placeholder.</p>
      </div>

      <div className="space-y-6 max-w-3xl">
        {gateways.map(g => (
          <div key={g.slug} className="bg-white rounded-2xl p-6" data-testid={`gateway-edit-${g.slug}`}>
            <div className="flex items-center justify-between mb-3">
              <h3 className="font-semibold text-[#0a0203]">{g.name}</h3>
              <span className="text-xs text-gray-400">/{g.slug}</span>
            </div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Video embed URL</label>
            <input
              value={g.video_url || ''}
              onChange={(e) => setVideo(g.slug, e.target.value)}
              className="w-full p-2.5 border rounded-lg mb-3"
              placeholder="e.g. https://www.youtube.com/embed/XXXX"
              data-testid={`gateway-video-input-${g.slug}`}
            />
            {g.video_url && (
              <div className="rounded-xl overflow-hidden aspect-video mb-3 bg-black">
                <iframe src={g.video_url} title={`${g.name} preview`} className="w-full h-full" frameBorder="0" allowFullScreen></iframe>
              </div>
            )}
            <button
              onClick={() => save(g)}
              disabled={saving === g.slug}
              className="inline-flex items-center gap-2 bg-[#003456] text-white font-semibold px-5 py-2.5 rounded-md hover:bg-[#002B47] transition-colors disabled:opacity-60"
              data-testid={`gateway-save-${g.slug}`}
            >
              {saving === g.slug ? <Loader2 className="h-4 w-4 animate-spin" /> : <Save className="h-4 w-4" />}
              {saving === g.slug ? 'Saving...' : 'Save'}
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default GatewaysTab;
